import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import ComingSoon from "../public/pages/ComingSoon";
import PublicLayout from "../layouts/PublicLayout";
import Home from "../public/pages/home/Home";
import TripDetailPage from "../public/pages/TripDetails/TripDetails";
import BookingSummary from "../public/pages/BookingSummary/BookingSummary";
import PaymentPage from "../public/pages/PaymentPage/PaymentPage";
import Thankyou from "../public/pages/ThankYouPage/Thankyou";
import PaymentLogin from "../public/pages/PaymentPage/PaymentLogin";
import { startSessionTimer } from "../utils/sessionManager";
import AttractionsSection from "../components/Attractions/AttractionsSection";
import MainAttraction from "../components/Attractions/MainAttraction";

export default function PublicRoutes() {
  useEffect(() => {
    startSessionTimer();
  }, []);
  return (
    <Routes>
      {/* Coming Soon */}
      <Route
        path="/"
        element={
          <ComingSoon />
        }
      />

      <Route
        path="/home"
        element={
          <PublicLayout>
            <Home />
          </PublicLayout>
        }
      />

      <Route
        path="/attractions"
        element={
          <PublicLayout>
            {/* <AttractionsSection /> */}
            <MainAttraction />
          </PublicLayout>
        }
      />

         <Route
        path="/attractionsWithSearch"
        element={
          <PublicLayout>
            <AttractionsSection />
          </PublicLayout>
        }
      />

      <Route
        path="/trip-details/:id"
        element={
          <PublicLayout>
            <TripDetailPage />
          </PublicLayout>
        }
      />


      <Route
        path="/booking-summary/"
        element={
          <PublicLayout>
            <BookingSummary />
          </PublicLayout>
        }
      />


      <Route
        path="/secure-checkout/:journeyId"
        element={
          <PublicLayout>
            <PaymentPage />
          </PublicLayout>
        }
      />


      <Route
        path="/thank-you/:journeyId"
        element={
          <PublicLayout>
            <Thankyou />
          </PublicLayout>
        }
      />

      <Route
        path="/payment-login"
        element={
          <PublicLayout>
            <PaymentLogin />
          </PublicLayout>
        }
      />

    </Routes>

  );
}
